module.exports = __webpack_public_path__ + "static/media/designsmart-promo.98dd4315.webp";